module.exports = __webpack_public_path__ + "static/img/watermark.ad6284e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/watermark.png
// module id = cGQ5
// module chunks = 192